import React from "react";
import { number, string } from "prop-types";

const EditIcon = ({ color = "#999999", width = 18, height = 15.997 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 15.997">
    <defs />
    <path
      fill={color}
      d="M12.581 2.7L15.4 5.516a.306.306 0 0 1 0 .431l-6.825 6.825-2.9.322A.608.608 0 0 1 5 12.422l.322-2.9L12.15 2.7a.306.306 0 0 1 .431 0zm5.063-.716L16.119.456a1.222 1.222 0 0 0-1.725 0l-1.106 1.107a.306.306 0 0 0 0 .431l2.819 2.819a.306.306 0 0 0 .431 0l1.106-1.106a1.222 1.222 0 0 0 0-1.726zM12 10.916V14.1H2v-10h7.181a.384.384 0 0 0 .266-.109l1.25-1.25a.375.375 0 0 0-.266-.641H1.5A1.5 1.5 0 0 0 0 3.6v11a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5V9.666a.376.376 0 0 0-.641-.266l-1.25 1.25a.384.384 0 0 0-.109.266z"
      transform="translate(0 -.1)"
    />
  </svg>
);

EditIcon.propTypes = {
  width: number,
  height: number,
  color: string
};

export default EditIcon;
